// @flow
import * as React from "react";
import {
  withRouter,
  type RouterHistory,
  type Location
} from "react-router-dom";
import idx from "idx";
import { connect } from "react-redux";
import styled, { ThemeProvider } from "styled-components";
import Gettext from "../../../common/Gettext";
import * as S from "./styles";
import { Text } from "./styles";
import TournamentAPI from "../../Api";
import RawHeader from "./Header";
import Button from "../../../Button";
import { InfoBlock } from "./StartInfo";
import { ColorfulCup } from "../../../Icons/Tournaments";

import { TradeThemeContext } from "../../../ThemeProvider";

const Wrapper = styled(S.Wrapper)`
  overflow: hidden;

  @media (max-width: 959px) {
    align-content: center;
    justify-content: center;
  }
`;

const CupIcon = styled(ColorfulCup)`
  display: block;
  flex-shrink: 0;

  @media (min-width: 960px) {
    margin: 0 auto 36px;
  }

  @media (min-width: 480px) and (max-width: 959px) {
    align-self: center;
    flex-basis: 54px;
  }

  @media (max-width: 479px) {
    margin: 0 auto 15px;
  }
`;

const Header = styled(RawHeader)`
  @media (min-width: 480px) and (max-width: 959px) {
    margin-bottom: 15px;
  }
`;

const Heading = styled(Text)`
  margin-bottom: 1em;
  font-size: 36px;
  color: ${({ theme }) => theme.lightWhiteAccent};

  @media (max-width: 959px) {
    font-size: 24px;
    margin-bottom: 0.5em;
  }

  @media (min-width: 480px) and (max-width: 959px) {
    font-size: 18px;
  }
`;

const ButtonContainer = styled.div`
  display: table;
  min-width: 163px;
  margin: 15px auto;

  @media (min-width: 480px) and (max-width: 959px) {
    margin: 9px auto;
  }
`;

const Title = styled(Text)`
  margin-bottom: 9px;

  @media (max-width: 959px) {
    line-height: 1.25;
    margin-bottom: 0.5em;
  }
`;

const Info = styled(S.Info)`
  @media (max-width: 959px) {
    margin-bottom: 15px;
  }
`;

type Props = {
  dispatch: Function,
  onDismiss: () => void,
  api: any,
  id: number,
  style: string,
  history: RouterHistory,
  location: Location
};

class StartPopup extends React.Component<Props, {}> {
  activateTournament = async (id: number) => {
    const { api, location, history } = this.props;

    const activate = await api.fetchEntity(
      `/api/tournaments/activate?id=${id}`
    );

    if (activate != null) {
      api.fetchEntity(`/api/tournaments/list?status=1`);
      api.fetchEntity("/api/tournaments/list?status=1&participation_status=1");
      api.fetchEntity(`/api/tournaments/info?id=${id}`);
      await api.fetchEntity(`/api/tournaments/stats`);
      this.props.dispatch({
        type: "ENGAGE_TOURNAMENT_MODE"
      });
      this.props.onDismiss();
      if (location.pathname !== "/trade") {
        history.push("/trade");
      }
    }
  };

  componentDidMount() {
    const { api, id } = this.props;

    if (typeof id === "number") {
      api.fetchEntity(`/api/tournaments/info?id=${id}`);
    }
  }

  render() {
    const { onDismiss, api, style, id, location } = this.props;

    switch (location.pathname) {
      case "/withdraw":
      case "/fillup":
      case "/verification":
        return null;
      default:
        break;
    }

    if (id == null) {
      return null;
    }

    const tournament = idx(
      api.readEntity(`/api/tournaments/info?id=${id}`),
      info => info.value
    );

    if (tournament == null) {
      return null;
    }

    const isAndroid = window.androidApp !== undefined;

    return (
      <S.Popup onDismiss={onDismiss} style={style} fades={false}>
        <Wrapper>
          <Header Cup={() => <CupIcon width="54px" />} {...tournament}>
            <Heading>
              <Gettext>GO!</Gettext>
            </Heading>
            <Title>
              <span>
                <Gettext>Tournament</Gettext>: {tournament.title}
              </span>
            </Title>
          </Header>
          <Info>
            <InfoBlock {...tournament} />
          </Info>
          <ButtonContainer>
            <Button
              color="yellow"
              withShadow={true}
              onClick={
                isAndroid
                  ? () => window.androidApp.tournamentTrade(tournament.id)
                  : () => this.activateTournament(tournament.id)
              }
            >
              <Gettext>Trade</Gettext>
            </Button>
          </ButtonContainer>
          <S.LinkContainer>
            <S.Link to={`/tournaments/${tournament.id}`} onClick={onDismiss}>
              <Gettext>Learn more</Gettext>
            </S.Link>
          </S.LinkContainer>
        </Wrapper>
      </S.Popup>
    );
  }
}

export default withRouter(
  connect()(props => {
    const api = React.useContext(TournamentAPI);
    const theme = React.useContext(TradeThemeContext);

    return (
      <ThemeProvider theme={theme}>
        <StartPopup {...props} api={api} key={props.id} />
      </ThemeProvider>
    );
  })
);



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Final/Start.js